import { contains } from "@service/helpers/domHelper";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { DropDownItem } from "./types";

@Component
export class DropdownBase extends Vue {

  @Prop({ default: () => ({ title: "", value: "" }) }) value: DropDownItem | DropDownItem[] | null;
  @Prop({ required: true }) list: DropDownItem[];
  @Prop({ default: true }) needCloseAfterSelect: boolean;

  opened = false;

  mounted() {
    document.addEventListener('click', this.clickOutsideHandler);
  }

  clickOutsideHandler(event: Event) {
    if (this.opened) {
      const parentElement = this.$parent.$el as HTMLElement;
      const dropDownElement = (this.$refs.dropDown ?? this.$el) as HTMLElement | null;
      const titleElement = this.$refs.title as HTMLElement | null;
      const target = event.target as HTMLElement;

      const isClickInside = contains(dropDownElement, target) || contains(titleElement, target) || contains(parentElement, target);

      if (!isClickInside) {
        this.opened = false;
      }
    }
  }

  select(item: DropDownItem) {
    if(this.isSelected(item)) {
      this.$emit('deselect', item);
    }
    else {
      this.$emit('select', item);

      if (this.needCloseAfterSelect) {
        this.opened = false;
      }
    }
  }

  isSelected(item: DropDownItem) {
    return Array.isArray(this.value) ? this.value.includes(item) : this.value?.id === item.id
  }

  @Watch('opened')
  watchOpened(opened: boolean) {
    if(!opened) {
      this.$emit('close')
    }
  }

  beforeDestroy() {
    document.removeEventListener('click', this.clickOutsideHandler);
  }
}
